var map = {
	"./alessandro.png": "8c2d",
	"./fabio.png": "7548",
	"./gabriela.png": "4025",
	"./italo.png": "bf46",
	"./jorge.png": "c2de",
	"./philipe.png": "eb3f",
	"./sergio.png": "f5ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0337";